var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 128,
    viewBox: "0 0 135 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 96C96.2998 96 116 76.3386 116 52C116 27.6614 96.213 8 72 8C47.7002 8 28 27.6614 28 52C28 76.3386 47.7002 96 72 96Z",
    fill: "#5B6276"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.433 38.2512C123.407 38.2512 125.007 36.6512 125.007 34.6774C125.007 32.7036 123.407 31.1035 121.433 31.1035C119.459 31.1035 117.859 32.7036 117.859 34.6774C117.859 36.6512 119.459 38.2512 121.433 38.2512Z",
    fill: "#5C6277"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.659 24.3047C128.007 24.3047 129.1 23.212 129.1 21.864C129.1 20.5161 128.007 19.4233 126.659 19.4233C125.311 19.4233 124.219 20.5161 124.219 21.864C124.219 23.212 125.311 24.3047 126.659 24.3047Z",
    fill: "#5C6277"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4329 23.2534C30.7808 23.2534 31.8735 22.1607 31.8735 20.8128C31.8735 19.4648 30.7808 18.3721 29.4329 18.3721C28.0849 18.3721 26.9922 19.4648 26.9922 20.8128C26.9922 22.1607 28.0849 23.2534 29.4329 23.2534Z",
    fill: "#5C6277"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5327 70.324C17.036 70.324 19.0654 68.2946 19.0654 65.7913C19.0654 63.288 17.036 61.2586 14.5327 61.2586C12.0294 61.2586 10 63.288 10 65.7913C10 68.2946 12.0294 70.324 14.5327 70.324Z",
    fill: "#5C6277"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_57624_136559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.603 94.0941H33.669C32.2287 94.0941 31.0469 92.9123 31.0469 91.472V73.4131C31.0469 71.9729 32.2287 70.7911 33.669 70.7911H107.603C109.043 70.7911 110.225 71.9729 110.225 73.4131V91.472C110.225 92.9123 109.043 94.0941 107.603 94.0941Z",
    fill: "url(#paint0_linear_57624_136559)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3355 79.5439H54.1584C53.272 79.5439 52.5704 79.0054 52.5704 78.3252C52.5704 77.645 53.272 77.1065 54.1584 77.1065H95.3355C96.2219 77.1065 96.9235 77.645 96.9235 78.3252C96.9235 79.0054 96.2219 79.5439 95.3355 79.5439Z",
    fill: "#626B80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5635 86.9668H54.1584C53.272 86.9668 52.5704 86.4283 52.5704 85.7481C52.5704 85.0679 53.272 84.5294 54.1584 84.5294H80.5635C81.4498 84.5294 82.1515 85.0679 82.1515 85.7481C82.1515 86.4283 81.4498 86.9668 80.5635 86.9668Z",
    fill: "#626B80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9799 88.9978C45.6104 88.9978 48.5535 86.0547 48.5535 82.4243C48.5535 78.7938 45.6104 75.8507 41.9799 75.8507C38.3494 75.8507 35.4063 78.7938 35.4063 82.4243C35.4063 86.0547 38.3494 88.9978 41.9799 88.9978Z",
    fill: "#626C80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5821 80.9252L40.446 85.0245L39.3907 83.9597L43.5269 79.8604L44.5821 80.9252Z",
    fill: "#2E3343"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.446 79.8604L44.5821 83.9597L43.5269 85.0245L39.3907 80.9252L40.446 79.8604Z",
    fill: "#2E3343"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_57624_136559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.088 34.6164H36.1533C34.713 34.6164 33.5312 33.4347 33.5312 31.9944V13.9355C33.5312 12.4952 34.713 11.3135 36.1533 11.3135H110.088C111.528 11.3135 112.71 12.4952 112.71 13.9355V31.9944C112.71 33.4347 111.528 34.6164 110.088 34.6164Z",
    fill: "url(#paint1_linear_57624_136559)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8198 20.0653H56.6427C55.7564 20.0653 55.0547 19.5268 55.0547 18.8466C55.0547 18.1664 55.7564 17.6279 56.6427 17.6279H97.8198C98.7062 17.6279 99.4078 18.1664 99.4078 18.8466C99.4078 19.5268 98.7062 20.0653 97.8198 20.0653Z",
    fill: "#626C80"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0478 27.4892H56.6427C55.7564 27.4892 55.0547 26.9507 55.0547 26.2705C55.0547 25.5903 55.7564 25.0518 56.6427 25.0518H83.0478C83.9341 25.0518 84.6358 25.5903 84.6358 26.2705C84.6358 26.9507 83.9341 27.4892 83.0478 27.4892Z",
    fill: "#626C80"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4642 29.5202C48.0947 29.5202 51.0378 26.5771 51.0378 22.9466C51.0378 19.3161 48.0947 16.373 44.4642 16.373C40.8337 16.373 37.8906 19.3161 37.8906 22.9466C37.8906 26.5771 40.8337 29.5202 44.4642 29.5202Z",
    fill: "#626C80"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9987 21.8032L43.3325 26.4694L40.7344 23.8713L41.7944 22.8113L43.3325 24.3493L46.9386 20.7432L47.9987 21.8032Z",
    fill: "#2E3343"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_57624_136559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7416 64.2151H24.7705C23.3302 64.2151 22.1484 63.0333 22.1484 61.593V43.5342C22.1484 42.0939 23.3302 40.9121 24.7705 40.9121H98.7047C100.145 40.9121 101.327 42.0939 101.327 43.5342V61.593C101.364 63.0702 100.182 64.2151 98.7416 64.2151Z",
    fill: "url(#paint2_linear_57624_136559)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1126 59.1559C36.7431 59.1559 39.6862 56.2128 39.6862 52.5824C39.6862 48.9519 36.7431 46.0088 33.1126 46.0088C29.4822 46.0088 26.5391 48.9519 26.5391 52.5824C26.5391 56.2128 29.4822 59.1559 33.1126 59.1559Z",
    fill: "#626C80"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7487 51.0444L32.0825 55.7106L29.4844 53.1125L30.5444 52.0525L32.0825 53.5905L35.6886 49.9844L36.7487 51.0444Z",
    fill: "#2E3343"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4839 49.6649H45.3067C44.4204 49.6649 43.7188 49.1264 43.7188 48.4462C43.7188 47.766 44.4204 47.2275 45.3067 47.2275H86.4839C87.3702 47.2275 88.0719 47.766 88.0719 48.4462C88.0719 49.1264 87.3333 49.6649 86.4839 49.6649Z",
    fill: "#626C80"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7118 57.1249H45.3067C44.4204 57.1249 43.7188 56.5864 43.7188 55.9062C43.7188 55.226 44.4204 54.6875 45.3067 54.6875H71.7118C72.5982 54.6875 73.2998 55.226 73.2998 55.9062C73.2629 56.5864 72.5612 57.1249 71.7118 57.1249Z",
    fill: "#626C80"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_57624_136559",
    x: 9.04694,
    y: 59.7911,
    width: 123.178,
    height: 67.3029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57624_136559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57624_136559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_57624_136559",
    x: 11.5312,
    y: 0.313477,
    width: 123.178,
    height: 67.3029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57624_136559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57624_136559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_57624_136559",
    x: 0.148438,
    y: 29.9121,
    width: 123.179,
    height: 67.3029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57624_136559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57624_136559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57624_136559",
    x1: 70.6103,
    y1: 70.2521,
    x2: 70.6103,
    y2: 94.3453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3B4153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57624_136559",
    x1: 73.0946,
    y1: 10.7745,
    x2: 73.0946,
    y2: 34.8676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3B4153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57624_136559",
    x1: 61.7122,
    y1: 40.3731,
    x2: 61.7122,
    y2: 64.4663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3B4153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDark);
export default __webpack_public_path__ + "static/media/empty-dark.ba0a2c46a863d74d7556d373b65ee4e0.svg";
export { ForwardRef as ReactComponent };